import config from '../../../config.json';
const env = process.env.REACT_APP_ENVIRONMENT || 'stage';
const BACKEND_URL = config.api[env];
import { backendAPI } from "../../helper/apis";

export function unBlockUser(userId) {
    return backendAPI.delete(`${BACKEND_URL}/v2/bo/user/block/${userId}`);
}